
/**
 * Module dependencies.
 */

import { fetchApplication } from 'src/api/app/applications/fetch-application';
import { fetchApplicationCollections, paginationLimit } from 'src/api/app/applications/fetch-application-collections';
import ApplicationPage, { Props } from 'src/components/pages/applications';
import React, { ReactElement } from 'react';

/**
 * `Application` page.
 */

const Application = (props: Props): ReactElement => (
  <ApplicationPage {...props} />
);

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, params, query }) {
  const data = await fetchApplication({
    hasPreview: query?.preview,
    locale,
    slug: params?.slug
  });

  if (!data) {
    return {
      notFound: true
    };
  }

  const products = await fetchApplicationCollections({
    applicationId: data?.id,
    locale,
    params: {
      limit: paginationLimit,
      page: 1
    }
  });

  return {
    props: {
      data,
      locale,
      products: {
        pageParams: [1],
        pages: [products ?? []]
      }
    }
  };
}

/**
 * Export `Application` page.
 */

export default Application;
